

const state = {
    
    blocks:[
        {
            id:1,
            name:'Stammdaten',
            color:'#fff',
            columns:2,
            blockcomponents: {
                columns: [
                    //left column
                    [
                       {
                            id:1,
                            name:'forminput',
                            attributes:{
                                    placeholder:"Street",
                                    size:"xs10",
                                    invertedsize:"xs1",
                                    hint:"Bitte die Strasse eingeben",
                                    icon:"edit",
                                    variable: 'street',
                                    setter: 'adresses/ADRESS_SET_STREET',
                                    rules:"required"
                            }
                        },
                        {
                            id:2,
                            name:'forminput',
                            attributes:{
                                    placeholder:"Zip",
                                    size:"xs5",
                                    invertedsize:"xs7",
                                    hint:"Bitte die PLZ eingeben",
                                    icon:"edit",
                                    variable: 'zip',
                                    setter: 'adresses/ADRESS_SET_ZIP',
                                    rules:"required"
                            }
                        },
                        {
                            id:3,
                            name:'forminput',
                            attributes:{
                                    placeholder:"City",
                                    size:"xs10",
                                    invertedsize:"xs1",
                                    hint:"Bitte die Stadt eingeben",
                                    icon:"edit",
                                    variable: 'city',
                                    setter: 'adresses/ADRESS_SET_CITY',
                                    rules:"required"
                            }
                        },  
                    ],                   
                    [
                        {
                            id:4,
                            name:'forminput',
                            attributes:{
                                    placeholder:"Country",
                                    size:"xs10",
                                    invertedsize:"xs1",
                                    hint:"Bitte das Land eingeben",
                                    icon:"edit",
                                    variable: 'country',
                                    setter: 'adresses/ADRESS_SET_COUNTRY'
                            }
                        },                       
                        {
                            id:5,
                            name:'forminput',
                            attributes:{
                                    placeholder:"Latitude",
                                    size:"xs6",
                                    invertedsize:"xs5",
                                    hint:"Bitte den Breitengrad eingeben",
                                    icon:"edit",
                                    variable: 'latitude',
                                    setter: 'adresses/ADRESS_SET_LATITUDE'
                            }
                        },
                        {
                            id:6,
                            name:'forminput',
                            attributes:{
                                    placeholder:"Longitude",
                                    size:"xs6",
                                    invertedsize:"xs5",
                                    hint:"Bitte den Längengrad eingeben",
                                    icon:"edit",
                                    variable: 'longitude',
                                    setter: 'adresses/ADRESS_SET_LONGITUDE'
                            }
                        }, 
                    ],                   
                ]
            }
        }
    ]

};

export default {
  namespaced: false,
  state,
  
};

                     
                    